"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _BoxRatioComponent.default;
  }
});

var _BoxRatioComponent = _interopRequireDefault(require("./BoxRatio-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }